import { z } from 'zod/v4';

import { CommonSearchParamsSchema } from '@/shared/utils/schemas';

export const audienceLibrarySearchParamsSchema =
  CommonSearchParamsSchema.extend({
    create: z.boolean().optional(),
  });

export type AudienceLibrarySearchParams = z.infer<
  typeof audienceLibrarySearchParamsSchema
>;

export const audienceLibraryFormSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  audienceId: z.string().optional(),
});

export type AudienceLibraryRequest = z.infer<typeof audienceLibraryFormSchema>;
